import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');

// Use hydrate if react-snap has pre-rendered the page (for SEO),
// otherwise use createRoot for normal SPA rendering.
if (rootElement.hasChildNodes()) {
    // react-snap pre-rendered: hydrate existing HTML
    const root = ReactDOM.hydrateRoot(rootElement, <App />);
} else {
    // Normal SPA: fresh render
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App />);
}